import { Controller } from "@hotwired/stimulus"

let accordionHasScrolledToError = false

export default class extends Controller {
  static targets = ["expandable", "subitem", "icon"]
  static values = {
    id: String
  }
  
  connect() {
    this.expandableElement = this.hasExpandableTarget ? 
    this.expandableTarget : 
    document.querySelector(`[data-accordion-id="${this.idValue}"]`)
    this.animating = false
    // Auto-expand if already marked as expanded in HTML
    if (this.element.getAttribute("aria-expanded") === "true") {
      const expandableHeight = this.totalHeight(this.expandableElement);
      this.expand(expandableHeight);
    }
    if (this.hasSubitemTarget) {
      this.subitemTargets.forEach((subitem, index) => {
        subitem.style.transitionDelay = `${(index + 1) * 50}ms`
      })
    }
    this.checkForErrorsAndExpand()
  }

  checkForErrorsAndExpand() {
    if (!this.expandableElement) return
    const errorElements = this.expandableElement.querySelectorAll('.error-messages')
    if (errorElements.length > 0) {
      const expandableHeight = this.totalHeight(this.expandableElement)
      this.expand(expandableHeight)
      this.element.setAttribute('aria-expanded', 'true')
      if (!accordionHasScrolledToError) {
        accordionHasScrolledToError = true
        setTimeout(() => {
          errorElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
        }, 600)
      }
    }
  }

  totalHeight(item) {
    console.log(item);
    console.log(window.getComputedStyle(item))
    const style = window.getComputedStyle(item)
    const paddingTop = parseFloat(style.paddingTop)
    const paddingBottom = parseFloat(style.paddingBottom)
    const marginTop = parseFloat(style.marginTop)
    const marginBottom = parseFloat(style.marginBottom)
    return item.scrollHeight + paddingTop + paddingBottom + marginTop + marginBottom
  }

  toggle(event) {
    if (this.animating) return
    const clickedElement = event.currentTarget
    const expandableHeight = this.totalHeight(this.expandableElement)
    if (this.element.getAttribute('aria-expanded') === 'true') {
      this.collapse(expandableHeight)
      clickedElement.setAttribute('aria-expanded', 'false')
    } else {
      this.expand(expandableHeight)
      clickedElement.setAttribute('aria-expanded', 'true')
    }
  }

  collapse(expandableHeight) {
    this.animating = true
    this.element.setAttribute('aria-expanded', 'false')
    this.expandableElement.setAttribute('aria-expanded', 'false')
    this.expandableElement.style.height = `${expandableHeight}px`
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = ""
    }
    
    setTimeout(() => {
      this.expandableElement.style.height = '0px'
      this.expandableElement.style.overflow = 'hidden'
    }, 10)
    
    setTimeout(() => {
      this.animating = false
      this.subitemTargets.forEach((subitem, index) => {
        subitem.style.transitionDelay = `${(index + 1) * 50}ms`
      })
    }, 500)
  }

  expand(expandableHeight) {
    this.animating = true
    this.element.setAttribute('aria-expanded', 'true')
    this.expandableElement.setAttribute('aria-expanded', 'true')
    this.expandableElement.style.height = `${expandableHeight}px`
    this.expandableElement.style.overflow = 'hidden'
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.iconTarget.dataset.transform
    }
    
    setTimeout(() => {
      this.expandableElement.style.height = 'auto'
      this.expandableElement.style.overflow = 'visible'
      this.animating = false
      this.subitemTargets.forEach((subitem) => {
        subitem.style.transitionDelay = '0ms'
      })
    }, 500)
  }
}
